export default {
    async mounted(this: { init: Function }) {
        await this.init()
    },
    watch: {
        '$i18n.locale': {
            async handler(this: { init: Function }) {
                await this.init()
            }
        }
    }
}